import React, { useEffect, useState } from "react";
import Axios from "../../axios/axios";

export default function PaymentReport() {
  const today = new Date().toISOString().split("T")[0];

  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);

  const [payments, setPayments] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [cashAmount, setCashAmount] = useState(0);
  const [upiAmount, setUpiAmount] = useState(0);

  useEffect(() => {
    fetchPaymentReport();
  }, []);

  const fetchPaymentReport = async () => {
    try {
      const res = await Axios.get(
        `/api/order/payment-report?from=${fromDate}&to=${toDate}`
      );

      setPayments(res.data.data || []);
      setTotalAmount(res.data.totalAmount || 0);
      setCashAmount(res.data.cashAmount || 0);
      setUpiAmount(res.data.upiAmount || 0);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchPaymentReport();
  }, [fromDate, toDate]);

  return (
    <div>
      {/* FILTER */}
      <div className="card mb-4">
        <div className="card-body d-flex gap-3 flex-wrap align-items-end">
          <div>
            <label>From</label>
            <input
              type="date"
              className="form-control"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>

          <div>
            <label>To</label>
            <input
              type="date"
              className="form-control"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>

          <button
            className="btn btn-primary"
            onClick={fetchPaymentReport}
          >
            Filter
          </button>
        </div>
      </div>

      {/* SUMMARY */}
      <div className="row mb-4">
        <div className="col-md-4">
          <div className="card bg-primary text-white">
            <div className="card-body">
              <h6>Total Amount</h6>
              <h3>₹ {totalAmount}</h3>
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card bg-success text-white">
            <div className="card-body">
              <h6>Cash Amount</h6>
              <h3>₹ {cashAmount}</h3>
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card bg-info text-white">
            <div className="card-body">
              <h6>UPI Amount</h6>
              <h3>₹ {upiAmount}</h3>
            </div>
          </div>
        </div>
      </div>

      {/* TABLE */}
      <div className="card">
        <div className="card-body">
          <h4>Payment Details</h4>

          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Order ID</th>
                  <th>Customer</th>
                  <th>Phone</th>
                  <th>Amount</th>
                  <th>Payment Method</th>
                  <th>Module</th>
                  <th>Date</th>
                </tr>
              </thead>

              <tbody>
                {payments.length > 0 ? (
                  payments.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>

                      <td>ADC_{item.orderId}</td>

                      <td>{item.customer}</td>

                      <td>{item.phone}</td>

                      <td>₹ {item.amount}</td>

                      <td>
                        <span
                          className={`badge ${
                            item.paymentMethod === "upi"
                              ? "bg-info"
                              : "bg-success"
                          }`}
                        >
                          {item.paymentMethod?.toUpperCase()}
                        </span>
                      </td>

                      <td>{item.module}</td>

                      <td>
                        {new Date(item.date).toLocaleDateString()}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center">
                      No Payments Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}